import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEventListener } from '@beef/react';
import { useEffect, useRef, useState } from 'react';
import { getSpaceVariable } from "../../../../utils/variables";
var DEFAULT_OFFSET = 20;
export var useContentScroll = function useContentScroll(ref) {
  var _useState = useState(DEFAULT_OFFSET),
    _useState2 = _slicedToArray(_useState, 2),
    buttonOffset = _useState2[0],
    setButtonOffset = _useState2[1];
  var contentRef = useRef(null);
  var defaultOffsetRef = useRef(0);
  useEffect(function () {
    defaultOffsetRef.current = getSpaceVariable(ref, 'l') - getSpaceVariable(ref, '2xs') || DEFAULT_OFFSET;
  }, []);
  var scrollAnalyze = function scrollAnalyze() {
    if (contentRef.current && ref.current) {
      setButtonOffset(Math.max(DEFAULT_OFFSET, ref.current.scrollTop - contentRef.current.offsetTop + defaultOffsetRef.current));
    }
  };
  useEventListener('scroll', scrollAnalyze, ref);
  return {
    contentRef: contentRef,
    buttonOffset: buttonOffset
  };
};